


export enum FORM_ACTION {
  /** 新增 */
  ADD = 1,
  /** 编辑 */
  EDIT = 2,
  /** 查看 */
  VIEW = 3,
  /** 删除 */
  DELETE = 4,
}
















